export const useImageHelper = () => {
  const {
    getImageUrlBySizeType,
    getImageUrlByDimensions,
    getImageUrlByHeight,
    getImageUrlByWidth,
    optimizeImageStoryblok,
  } = useUtils();

  const getFilteredSrc = (src: any) => {
    if (Array.isArray(src)) {
      return {
        ...src,
        urls: src.filter((obj) => obj.sizeType !== 'BO'),
      };
    }
    return src;
  };

  const getUrlBySizeTypeOrDimensions = (
    src: any,
    sizeType: string,
    width: number | string,
    height: number | string
  ) => {
    if (sizeType) return getImageUrlBySizeType(src, sizeType);
    if (width && height) return getImageUrlByDimensions(src, Number(width), Number(height));
    if (width) return getImageUrlByWidth(src, Number(width));
    if (height) return getImageUrlByHeight(src, Number(height));
    return null;
  };

  const getStoryblokUrl = (src: string, width?: number | string, height?: number | string) => {
    const size = `${width ?? 0}x${height ?? 0}`;
    return optimizeImageStoryblok(src, size);
  };

  return {
    getFilteredSrc,
    getUrlBySizeTypeOrDimensions,
    getStoryblokUrl,
  };
};
